import moment from 'moment'
import { store } from 'services/configureStore'
import {
  SHOW_LOCALE_MODAL,
  CLOSE_LOCALE_MODAL,
  CHANGE_LOCALE,
  SKIP_GOAL_SETTING,
  SHOW_SUPPORT_CHAT,
  HIDE_SUPPORT_CHAT,
  SUPPORT_CHAT_IS_READY
} from './actionTypes'

export const showLocaleModal = () => dispatch => dispatch({ type: SHOW_LOCALE_MODAL })
export const closeLocaleModal = () => dispatch => dispatch({ type: CLOSE_LOCALE_MODAL })
export const changeLocale = locale => dispatch => dispatch({ type: CHANGE_LOCALE, locale })

export const showSupportChat = () => dispatch => dispatch({ type: SHOW_SUPPORT_CHAT })
export const hideSupportChat = () => dispatch => dispatch({ type: HIDE_SUPPORT_CHAT })
export const setSupportChatIsReady = () => dispatch => dispatch({ type: SUPPORT_CHAT_IS_READY })

export const skipGoalSetting = () => dispatch => {
  const { user } = store.getState();
  const login = user ? user.login : '';
  const date = moment().format('MM.YYYY');

  dispatch({
    type: SKIP_GOAL_SETTING,
    data: {
      goalSettingSkip: `${login}_${date}`
    }
  })
}
